import(/* webpackMode: "eager" */ "/home/ubuntu/download/697512271beda800144fd2bf/pink_diamond_corporate/src/app/not-found.tsx");
